export default __webpack_public_path__ + "static/media/dropdown-indicator-icon.578b446e.svg";